import React from 'react';
import StationHealth from './StationHealth';
import styles from './Settings.module.scss';

import type { JetsonHealthDTO } from '../../types/jetson';

interface SettingsProps {
  jetsonsHealth: JetsonHealthDTO[];
}

const Settings: React.FC<SettingsProps> = ({ jetsonsHealth }) => {
  return (
    <div className={styles.container}>
      {jetsonsHealth.map((jetsonHealth, index) => (
        <StationHealth key={index} stationHealth={jetsonHealth} />
      ))}
    </div>
  );
};

export default Settings;
